import React from "react";

const GrowthBadge = ({ value }) => {
  if (value === undefined || value === null) return null;
  const positive = value >= 0;
  return (
    <span className={`sad-growth ${positive ? "sad-growth--up" : "sad-growth--down"}`}>
      {positive ? "▲" : "▼"} {Math.abs(value)}%
    </span>
  );
};

export default GrowthBadge;
